import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ScWithMinMaxFieldsFragmentDoc, ScFieldsFragmentDoc } from './share-class.graphql';
export type GqlSiFieldsFragment = { approvedByMeeting?: boolean | null, boardsStatementDate?: string | null, boardsStatementEn?: string | null, boardsStatementOption?: Types.GqlBoardsStatementOption | null, boardsStatementSv?: string | null, companyId: string, createdAt: string, description: string, id: string, maxNumberOfShares?: string | null, minNumberOfShares?: string | null, nonCashStatementPl?: string | null, nonCashStatementSl?: string | null, numberOfSharesBefore?: string | null, paidForAt?: string | null, paymentKindCash: boolean, paymentKindNonCash: boolean, paymentKindOffset: boolean, preferentialRights: boolean, pricePerShare?: string | null, maxPaidAmount?: string | null, currency: Types.GqlCurrency, primaryLang: boolean, published?: boolean | null, quotaValue?: string | null, restrictedToParticipants?: boolean | null, secondaryLang: boolean, snrAuthorizationId?: string | null, snrShareCapitalChangeId?: string | null, stripeInvoiceId?: string | null, subscriptionEndDate?: string | null, subscriptionStartDate?: string | null, updatedAt: string, purpose: Types.GqlShareIssuePurpose, decisionKind?: Types.GqlDecisionKind | null, paymentCount: { paid: number, waiting: number, notPaid: number }, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null, min: string, max: string }> };

export const SiFieldsFragmentDoc = gql`
    fragment SiFields on ShareIssue {
  approvedByMeeting
  boardsStatementDate
  boardsStatementEn
  boardsStatementOption
  boardsStatementSv
  companyId
  createdAt
  description
  id
  maxNumberOfShares
  minNumberOfShares
  nonCashStatementPl
  nonCashStatementSl
  numberOfSharesBefore
  paidForAt
  paymentKindCash
  paymentKindNonCash
  paymentKindOffset
  preferentialRights
  pricePerShare
  maxPaidAmount
  currency
  primaryLang
  published
  quotaValue
  restrictedToParticipants
  secondaryLang
  paymentCount {
    paid
    waiting
    notPaid
  }
  shareClasses {
    ...ScWithMinMaxFields
  }
  snrAuthorizationId
  snrShareCapitalChangeId
  stripeInvoiceId
  subscriptionEndDate
  subscriptionStartDate
  updatedAt
  purpose
  decisionKind
}
    ${ScWithMinMaxFieldsFragmentDoc}`;